export default function ({ $auth }) {
  if (!$auth?.loggedIn) {
    $auth?.loginWith('custom')
  }
}
